/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

import { Injectable, Inject } from '@angular/core';

export function initialize(module: ng.IModule) {
    module.service(CompetenceTypeDataService.Id, CompetenceTypeDataService);

    CompetenceTypeDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class CompetenceTypeDataService extends base.BaseDataService<Nema.Crew.Model.CompetenceType> implements ICompetenceTypeDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }
    
    public static Id = "competenceTypeDataService";

    public get EntityName(): string {
        return "CompetenceType";
    }

    public get EntitiesName(): string {
        return "CompetenceTypes";
    }
}

export interface ICompetenceTypeDataService extends base.IDataService<Nema.Crew.Model.CompetenceType> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/competencetypes.dataservice.ts